import { VideoJsPlayer } from '@app/core/video-player/video-js/VideoJsPlayer';
import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { socialExportPublishMessages } from './social-export-publish-messages';

export interface SocialExportVideoPreviewProps {
  /** URL of the video to preview. When null, nothing is rendered. */
  videoUrl: string | null;
}

/**
 * Preview of the media that will be uploaded to the social platform (shared compose + fragment upload wizard).
 */
export function SocialExportVideoPreview({ videoUrl }: SocialExportVideoPreviewProps) {
  if (!videoUrl) {
    return null;
  }

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        <FormattedMessage {...socialExportPublishMessages.videoPreviewTitle} />
      </Typography>
      <Box sx={{ borderRadius: 1, overflow: 'hidden', bgcolor: 'action.hover' }}>
        <VideoJsPlayer bordered src={videoUrl} sx={{ width: '100%', maxWidth: 1 }} />
      </Box>
    </Box>
  );
}
